import { render } from "./IDateSelect.vue?vue&type=template&id=5672a165&scoped=true"
import script from "./IDateSelect.vue?vue&type=script&lang=js"
export * from "./IDateSelect.vue?vue&type=script&lang=js"

import "./IDateSelect.vue?vue&type=style&index=0&id=5672a165&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5672a165"]])

export default __exports__